








































































































































































import { Component, Prop } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import { mixins } from "vue-class-component";
import RequestPromises from "@/mixins/requestPromises";

// Types
import { IClientForm } from "@/models/clients";
import { IState } from "@/store";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";
import { ILead } from "@/models/leads";
import { IClient } from "@/models/clients";
import { IBrand } from "@/models/brands";
import { UUID } from "@/data/enums";

@Component({
  components: {
    "custom-fields": () =>
      import("@/components/app/global/customFields/customFields.vue")
  },
  computed: {
    ...mapState({
      brandId(state: IState) {
        return state.auth.admin.brandId;
      }
    })
  }
})
export default class AddClientModal extends mixins(
  RequestPromises,
  HasValidation,
  Context
) {
  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    firstname: HTMLFormElement;
    customFields: HTMLFormElement;
  };

  //Props
  @Prop({ required: false, default: () => ({}) })
  public lead!: ILead;

  // :getters
  public brandId!: IBrand["id"];

  private form: IClientForm = {
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    verified: false,
    has_login: true,
    custom_fields: {},
    brand_id: UUID.ORG
  };

  private dataModule: string = DataModules.CLIENTS;
  private customFieldsDataModule: string = DataModules.CUSTOM_FIELDS_CLIENTS;
  private isLoading = true;
  private isProcessing = false;

  private created() {
    this.form.brand_id = this.brandId
      ? this.brandId
      : this.getBrands.length
      ? this.getBrands[0].id
      : UUID.ORG;

    if (this.createFromLead) {
      this.form.brand_id = this.lead.brand_id;
      this.form.email = this.lead.email;
      const names = this.lead.name.split(" ");
      this.form.firstname = names[0];
      this.form.lastname = this.lead.name.replace(names[0], "").trim();
    }
  }

  private onLoad() {
    this.isLoading = false;
    this.$nextTick(() => {
      this.$refs.firstname.$el.querySelector("input").focus();
    });
  }

  public get isOrgMode() {
    return this.brandId === UUID.ORG;
  }

  private get getBrands() {
    return this.$_.filter(
      this.$_.get(this.$store, "state.auth.admin.brands", []),
      brand => {
        return brand.id !== UUID.ORG;
      }
    );
  }

  private get formIsDisabled() {
    return this.isProcessing || this.hasErrors || this.isLoading;
  }

  private get createFromLead() {
    return !this.$_.isEmpty(this.lead);
  }

  private async validateBeforeSubmit() {
    if (this.$userCan("create_client")) {
      this.isProcessing = true;

      try {
        const result = await this.validate();
        if (!result) {
          throw this.$t("_sentence.form_is_not_valid");
        }

        await this.$refs["customFields"].uploadCustomImages();
        const newClient = await this.createClient();

        this.$buefy.toast.open({
          message: this.$t("_.object_successfully_added", {
            object: this.$t("_.client")
          }) as string
        });

        this.$router.push({
          name: "adminClient",
          params: {
            clientId: newClient.id
          }
        });

        this.$emit("close");
      } catch (error) {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      }

      this.isProcessing = false;
    }
  }

  private createClient(): Promise<IClient> {
    if (!this.form.has_login) {
      delete this.form.verified;
    }
    if (this.createFromLead) {
      return this.$store.dispatch(`data/${DataModules.LEADS}/createClient`, {
        id: this.lead.id,
        data: this.form
      });
    }
    return this.$store.dispatch(`data/${this.dataModule}/create`, {
      data: this.form
    });
  }
}
